<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        module="basic"
        url="esopChangeDetails"
        :columns-property="columnsProperty"
        :table-select="false"
        :limits="limits"
        @reset="resetHandle"
        @delete="deleteHandle"
        @addOrEdit="addEditHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="编号">
              <el-input v-model.trim="filter.esopNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="变更描述">
              <el-input v-model.trim="filter.changeNote" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="变更类型">
              <el-select v-model="filter.changeType" placeholder="请选择" clearable>
                <el-option label="新建变更" :value="10"/>
                <el-option label="编辑变更" :value="20"/>
                <el-option label="提交变更" :value="30"/>
              </el-select>
            </el-form-item>
            <el-form-item label="状态">
              <!--              <el-select v-model="filter.changeStatusName" placeholder="请选择" clearable>-->
              <!--                <el-option label="草稿" value="草稿"/>-->
              <!--                <el-option label="电抗线绕" value="电抗线绕"/>-->
              <!--                <el-option label="电抗箔绕" value="电抗箔绕"/>-->
              <!--                <el-option label="电阻" value="电阻"/>-->
              <!--                <el-option label="滤波器" value="滤波器"/>-->
              <!--                <el-option label="线绕负责人" value="线绕负责人"/>-->
              <!--                <el-option label="箔绕负责人" value="箔绕负责人"/>-->
              <!--                <el-option label="电阻负责人" value="电阻负责人"/>-->
              <!--                <el-option label="滤波器负责人" value="滤波器负责人"/>-->
              <!--                <el-option label="提交人确认" value="提交人确认"/>-->
              <!--                <el-option label="退回" value="退回"/>-->
              <!--              </el-select>-->
              <el-select
                  v-model="biddingStage"
                  :popper-append-to-body="false"
                  multiple
                  clearable
                  placeholder="请选择"
                  @change="handleSelect">
                <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>

      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="limits.downAuth"
            type="primary"
            :disabled="scope.row.imgPath === ''||scope.row.imgPath===null"
            @click="downHandle(scope.row.imgPath)"
        >
          下载
        </el-button>
      </template>
    </view-table>
    <!-- 变更记录 -->
    <replace-record ref="replaceRecord"/>
    <esop-change-edit ref="changeEdit" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import ReplaceRecord from "@/views/information/Esop/ReplaceRecord.vue";
  import EsopChangeEdit from "@/views/information/EsopChange/EsopChangeEdit";

  export default {
    name: "EsopChangeList",
    components: {
      ViewTable,
      ReplaceRecord,
      EsopChangeEdit,
    },
    data() {
      return {
        limits: {
          addAuth: this.$auth(505),
          editAuth: this.$auth(506),
          delAuth: this.$auth(507),
          downAuth: 192,
        },
        filter: {
          esopNo: "",
          materialName: "",
          changeType: 30,
          changeStatusName: "",
          changeStatusNames: "",
          materialNo: "",
          specification: "",
          changeNote: "",
        },
        biddingStage: [],
        options: [
          {name: "草稿", value: "草稿"},
          {name: "电抗线绕", value: "电抗线绕"},
          {name: "电抗箔绕", value: "电抗箔绕"},
          {name: "电阻", value: "电阻"},
          {name: "滤波器", value: "滤波器"},
          {name: "线绕负责人", value: "线绕负责人"},
          {name: "箔绕负责人", value: "箔绕负责人"},
          {name: "电阻负责人", value: "电阻负责人"},
          {name: "滤波器负责人", value: "滤波器负责人"},
          {name: "提交人确认", value: "提交人确认"},
          {name: "退回", value: "退回"},
        ],
        billId: "",
        billType: "",
        columnsProperty: [
          {
            key: "esopNo",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  {
                    style: {
                      color: "#2d8cf0",
                      cursor: "pointer",
                    },
                    on: {
                      click: () => {
                        this.replaceRecordClick(params.row);
                        // this.$refs.replaceRecord.open(params.row);
                      },
                    },
                  },
                  params.row.esopNo,
              );
            },
          },
          {
            key: "action",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    watch: {
      "filter.changeStatusNames": {
        handler(val) {
          if (val) {
            this.biddingStage = [];
            this.options.map(item => {
              val.split(",").forEach((s) => {
                if (s == item.value) {
                  this.biddingStage.push(item.value);
                }
              });
            });
          }
        },
      },
    },
    methods: {
      handleSelect(value) {
        if (value.length) {
          this.biddingStage = value;
          this.filter.changeStatusNames = value.join(",");
        } else {
          this.biddingStage = [];
          this.filter.changeStatusNames = "";
        }
      },
      replaceRecordClick(row) {
        this.$http
            .get("basic", `esops/${row.esopId}`)
            .then((resp) => {
              if (resp.success) {
                // this.data = resp.data;
                this.billId = resp.data.esopChangeId + "";
                this.billType = resp.data.workFlowType + "";
                this.$refs.replaceRecord.open(resp.data, this.billId, this.billType);
              }
            });
      },
      download(filePath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      downHandle(filePath) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        if (row) {
          this.$refs.changeEdit.open(1, row.masterId);
        } else {
          this.$refs.changeEdit.open(0, null);
        }
      },

      // 删除
      deleteHandle(row) {
        this.$http.delete("basic", "esops", row.masterId).then((res) => {
          if (res.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      otherAuth(row) {
        if (row.status === 0) {
          return {
            editAuth: false,
            delAuth: false,
          };
        } else if (row.status === 5) {
          return {
            editAuth: false,
            delAuth: true,
          };
        } else {
          return {
            editAuth: true,
            delAuth: true,
          };
        }
      },
    },
  };
</script>

<style lang="scss">
.ivu-table td,
.ivu-table th {
  height: 37px;
  font-size: 13px;

  .el-button--mini {
    padding: 7px 10px;
  }
}
</style>
